/* eslint-disable */
import { store } from '../store'
import router from '../router'
import { http, httpgst } from '../main'

export const actions = {
  login({ commit, dispatch }, payload) {
    let url = 'oauth/token'
    let params = {
      grant_type: process.env.GRANT_TYPE,
      client_secret: process.env.CLIENT_SECRET,
      client_id: process.env.CLIENT_ID,
      username: payload.event.email,
      password: payload.event.password
    }
    let options = {
      emulateJSON: true,
      headers: {
        // 'Content-Type': 'multipart/form-data',
        accept: 'application/json'
      }
    }
    http.post(url, params, options).then(
      response => {
        payload.event.context.setLogin(false)
        localStorage.setItem(
          'token',
          JSON.stringify({
            access_token: response.data.access_token,
            expires_in: response.data.expires_in,
            refresh_token: response.data.refresh_token,
            token_type: response.data.token_type
          })
        )
        commit('login', {
          email: payload.event.email,
          access_token: response.data.access_token,
          expires_in: response.data.expires_in,
          refresh_token: response.data.refresh_token,
          token_type: response.data.token_type
        })
        router.replace('/dashboard')
      },
      error => {
        console.log(error.response)
        payload.event.context.loading = false
        payload.event.context.setError(true, error.response.data.message)
      }
    )
    // .catch(error => {
    //   payload.event.context.loading = false
    //   payload.event.context.setError(true, error.response.data.message)
    // })
  },
  logout({ commit, dispatch }, payload) {
    let url = 'api/logout'
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.get(url, {}, options).then(
      response => {
        localStorage.clear()
        commit('logout', {})
        router.replace('/')
      },
      error => {
        console.log('error!', error.response)
        localStorage.removeItem('token')
        commit('logout', {})
        router.replace('/')
      }
    )
  },
  getSatFormaPago({ commit, dispatch }, payload) {
    let url = 'api/sat/forma-pago'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options).then(
      response => {
        commit('onGetFormaPago', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getSatMetodoPago({ commit, dispatch }, payload) {
    let url = 'api/sat/metodo-pago'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options).then(
      response => {
        commit('onGetMetodoPago', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getSatMoneda({ commit, dispatch }, payload) {
    let url = 'api/sat/moneda'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options).then(
      response => {
        commit('onGetMoneda', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getSatPais({ commit, dispatch }, payload) {
    let url = 'api/sat/pais'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options).then(
      response => {
        commit('onGetPais', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getCompany({ commit, dispatch }, payload) {
    let url = 'api/company/' + payload.event.id
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options).then(
      response => {
        commit('onGetCompany', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getCompanies({ commit, dispatch }, payload) {
    let url = 'api/company'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options).then(
      response => {
        commit('onGetCompanies', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  readXml({ commit, dispatch }, payload) {
    let url = 'api/read-xml'
    let params = {
      file_id: payload.event.file_id,
      files_type_id: 7
    }
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.post(url, params, options).then(
      response => {
        commit('onReadXml', { event: payload.event, response: response })
      },
      error => {
        commit('onReadXmlError', { event: payload.event, error: error })
      }
    )
  },
  async readXmlToHtml({ commit, dispatch }, payload) {
    let url = 'api/read-xml/' + payload.event.id + '/convert-to/html'

    // let url = 'api/read-xml/60/convert-to/html'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    http.get(url, {}, options).then(
      response => {
        if (
          payload.event.type
            ? payload.event.type === 'viewItemsApprobedF'
            : false
        ) {
          commit('onReadXmlToHtmlFA', {
            event: payload.event,
            response: response
          })
        } else if (
          payload.event.type ? payload.event.type === 'viewItemsF' : false
        ) {
          commit('onReadXmlToHtmlFV', {
            event: payload.event,
            response: response
          })
        } else {
          commit('onReadXmlToHtml', {
            event: payload.event,
            response: response
          })
        }
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  userLogged({ commit, dispatch }, payload) {
    let url = 'api/user-logged'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    if (store.state.userState !== null) {
      http.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token
      http.defaults.headers.common['X-device'] = 'WEB'
      http.get(url, {}, options).then(
        response => {
          commit('onUserLogged', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
          router.replace('/logout')
        }
      )
    }
  },
  altLogin({ commit, dispatch }, payload) {
    payload.event.context.setLogin(false)
    localStorage.setItem(
      'token',
      JSON.stringify({
        email: payload.event.email
      })
    )
    commit('login', {
      email: payload.event.email
    })
    router.replace('/dashboard')
  },
  altLogout({ commit, dispatch }, payload) {
    localStorage.clear()
    commit('logout', {})
    router.replace('/')
  },
  getPlans({ commit, dispatch }, payload) {
    let url = 'api/plans'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options).then(
      response => {
        commit('onGetPlans', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getStatus({ commit, dispatch }, payload) {
    let url = 'api/catalog/gst_expenses_status'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetStatus', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getCategories({ commit, dispatch }, payload) {
    let url = 'api/categories'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetCategories', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getAreas({ commit, dispatch }, payload) {
    let url = 'api/areas'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetAreas', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getFile({ commit, dispatch }, payload) {
    let url = 'api/File/' + payload.event.fileId + '/get'
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, {}, {}).then(
      response => {
        commit('onGetFile', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  downloadXML({ commit, dispatch }, payload) {
    let url = 'api/File/' + payload.event.fileId + '/get'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, options).then(
      response => {
        commit('onDownloadXML', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  downloadFile({ commit, dispatch }, payload) {
    let url = 'api/File/' + payload.event.fileId + '/get'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, options).then(
      response => {
        commit('onDownloadFile', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getZip({ commit, dispatch }, payload) {
    let url = 'api/File/' + payload.event.fileId + '/get'
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, {}, {}).then(
      response => {
        commit('onGetZip', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getBranchesCompany({ commit, dispatch }, payload) {
    let url = `api/branches-company/${payload.event.item.companyId}`
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options).then(
      response => {
        commit('onGetBranchesCompany', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getAreasCompany({ commit, dispatch }, payload) {
    let url = `api/areas-company/${payload.event.item.companyId}`
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetAreasCompany', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getProjectsCompany({ commit, dispatch }, payload) {
    let url = `api/projects/getProjects/${payload.event.item.companyId}`
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options).then(
      response => {
        commit('onGetProjectsCompany', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  changeAvatar({ commit, dispatch }, payload) {
    let url = 'api/user/' + store.state.userLogged.id
    let params = {
      avatar: payload.event.context.avatarId
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.put(url, params, {}).then(
      response => {
        commit('onChangeAvatar', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  changeLogo({ commit, dispatch }, payload) {
    let url = 'api/company/' + store.state.userLogged.company[0].id
    let params = {
      logo: payload.event.context.avatarId
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.put(url, params, {}).then(
      response => {
        commit('onChangeLogo', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  changePassword({ commit, dispatch }, payload) {
    let url = 'api/reset-password'
    let params = {
      oldPassword: payload.event.oldPass,
      newPassword: payload.event.newPass
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.put(url, params, {}).then(
      response => {
        commit('onChangePass', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  resetPassword({ commit, dispatch }, payload) {
    let url = 'api/reset-password'
    let params = {
      email: payload.event.email
    }
    http.post(url, params, {}).then(
      response => {
        commit('onResetPass', { event: payload.event, response: response })
      },
      error => {
        commit('onResetPassError', { event: payload.event, error: error })
      }
    )
  },
  getContacts({ commit, dispatch }, payload) {
    let url = 'api/contact'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options).then(
      response => {
        commit('onContacts', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  deleteContact({ commit, dispatch }, payload) {
    let url = 'api/contact/' + payload.event.id
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.delete(url, {}, {}).then(
      response => {
        commit('onDeleteContact', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  downloadExpensesFiles({ commit, dispatch }, payload) {
    let url = 'api/zip-download'
    let params = {
      expensesItems: payload.event.expensesItems.items
    }
    let config = {
      responseType: 'blob'
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, config).then(
      response => {
        commit('onDownloadExpensesFiles', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js